var React = require('react');

function MapIconGrey (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.99984 0.666748C2.77484 0.666748 0.166504 3.27508 0.166504 6.50008C0.166504 10.8751 5.99984 17.3334 5.99984 17.3334C5.99984 17.3334 11.8332 10.8751 11.8332 6.50008C11.8332 3.27508 9.22484 0.666748 5.99984 0.666748ZM5.99984 8.58342C4.84984 8.58342 3.9165 7.65008 3.9165 6.50008C3.9165 5.35008 4.84984 4.41675 5.99984 4.41675C7.14984 4.41675 8.08317 5.35008 8.08317 6.50008C8.08317 7.65008 7.14984 8.58342 5.99984 8.58342Z","fill":"#4F5A63"}));
}

MapIconGrey.defaultProps = {"width":"12","height":"18","viewBox":"0 0 12 18","fill":"none"};

module.exports = MapIconGrey;

MapIconGrey.default = MapIconGrey;
